import React from 'react';

/**
 * Tile primitives. Mirrors the prototype's `.tile-row` / `.tile-row-3` /
 * `.tile` / `.tile-title` / `.stat-grid` / `.stat-box` / `.stat-num` / `.stat-lbl`.
 *
 *  <TileRow cols={3}>
 *      <Tile title="Identity">...</Tile>
 *      <Tile title="...">...</Tile>
 *      <Tile title="...">...</Tile>
 *  </TileRow>
 *
 *  <StatGrid>
 *      <StatBox num="$12,480" lbl="Total commission" />
 *  </StatGrid>
 */
export const TileRow = ({cols, children, className = '', ...rest}) => {
    const cn = cols === 3 ? 'tile-row tile-row-3' : 'tile-row';
    const finalCn = [cn, className].filter(Boolean).join(' ');
    return (
        <div className={finalCn} {...rest}>
            {children}
        </div>
    );
};

export const Tile = ({title, children, className = '', ...rest}) => {
    const cn = ['tile', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {title && <div className="tile-title">{title}</div>}
            {children}
        </div>
    );
};

export const StatGrid = ({children, className = '', ...rest}) => {
    const cn = ['stat-grid', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {children}
        </div>
    );
};

export const StatBox = ({num, lbl, className = '', ...rest}) => {
    const cn = ['stat-box', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            <div className="stat-num">{num}</div>
            <div className="stat-lbl">{lbl}</div>
        </div>
    );
};
